import { ChipButton, ChipTitle, ChipWrapper } from './styles';
import { ReactNode } from 'react';

type ChipType = {
  title?: string;
  onClick: () => void;
  isRemovable?: boolean;
  children: ReactNode;
};

export const Chip = ({ title, onClick, isRemovable, children }: ChipType) => {
  return (
    <ChipWrapper title={title}>
      <ChipTitle>{children}</ChipTitle>
      {isRemovable && <ChipButton onClick={onClick}>&times;</ChipButton>}
    </ChipWrapper>
  );
};
